import React from 'react';

const EmptyList: React.FC<{ message: string }> = ({ message }) => {
  return (
    <>
      <div className="d-flex justify-content-center align-items-center p-4 text-center">
        <p className="empty-list-message mb-0">{message}</p>
      </div>
    </>
  );
};

export default EmptyList;
